import React, {useContext, useEffect, useState } from 'react';
import NoLogoImg from '../../../src/assests/img/no-logo.jpg';
import {getCarrierData} from '../common/api/getApiData';
import {filterData} from '../common/components/DropdownFilter';
import classNames from 'classnames';
import {FilterContext} from '../common/context/filterContext';
import {formatCarrierData} from '../common/functions/formatData';
import Loader from '../common/components/Loader';
import {AuthContext} from '../common/context/authContext';
import Search from '../common/components/Search';
import SheildIcon from '../../assests/img/sheild.svg?url';
import '../../../src/assests/css/wholesaler.scss';

function Wholesaler() {

    const {filterData: {wholesaler, contacts, carrier,
        facilityType, coverage, categories,
        companyCategories}} = useContext(FilterContext);
    const {accounts} = useContext(AuthContext);
    const [wholesalers, setWholesalers] = useState<any []>([]);
    const [wholesalersData, setWholesalersData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [selected, setSelected] = useState<filterData>({id: 0, value: ''});

    const getWholesalerData = async (id: number) => {
        setLoading(true);
        const res = await getCarrierData(`CompanyDetail/?$filter=CompanyId eq ${id}`,
            accounts);
        const data = formatCarrierData(res, carrier, contacts, facilityType,
            coverage, categories, companyCategories);
        setWholesalersData(data);
        setLoading(false);
    }

    const handleWholesalerSelect = (selected: filterData) => {
        setSelected(selected);
        getWholesalerData(selected.id);
    }

    const filterWholsalers = (text: string) => {
        if (text.length) {
            const filteredData = wholesalers.filter((data)=>
                data.value.toLowerCase().includes(text.toLowerCase()));
            setWholesalers(filteredData);
        } else {
            setWholesalers(wholesaler.slice(1, wholesaler.length));
        }
    }

    useEffect(()=> {
        setWholesalers(wholesaler.slice(1, wholesaler.length));
    }, [
    ]);

    return (
        <div className="wholesaler-container">
            <div className="filters-container">
                <div className="wholesaler-filter-container">
                    <div className="wholesaler-title">
                        Wholesaler ({wholesalers.length})
                    </div>
                    <div className="wholesaler-search-container">
                        <Search onChange={(text) => filterWholsalers(text)} customClassName='w-auto'/>
                    </div>
                    <div className="wholesaler-select-container">
                        {wholesalers.map(({id, value, Logo})=> {
                            return (
                                <div key={`wholesaler-select-item-${id}`}
                                    className={classNames(
                                        'wholesaler-select-item',
                                        selected.id === id? 'selected': '')}
                                    onClick={()=>
                                        handleWholesalerSelect({id, value})}>
                                    <span> <img src= {Logo? Logo: NoLogoImg}
                                        width={'32px'}
                                        className="wholesaler-item-img"/> </span>
                                    <span> {value} </span>
                                </div>
                            );
                        })}
                    </div>
                </div> 
            </div>
            <div className="content-container">
                <div className="wholesaler-content">
                    <table className="wholesaler-table">
                        <thead>
                        <tr className="wholesaler-table-heading">
                            <th className="wholesaler-table-heading-text">LOB</th>
                            <th className="wholesaler-table-heading-text">Underwriter Name</th>
                            <th className="wholesaler-table-heading-text">Designation & Department</th>
                            <th className="wholesaler-table-heading-text">Phone</th>
                            <th className="wholesaler-table-heading-text">Mobile</th>
                            <th className="wholesaler-table-heading-text">Email</th>
                        </tr>
                        </thead>
                        <tbody>
                        {!loading? wholesalersData.map((data: any, index)=> {
                            return (
                            <tr key={`wholesaler-item-${index}`}
                                className="wholesaler-table-content">
                                <td className="wholesaler-table-content-text coverage">
                                    <img src={
                                        data.coverage.logo? data.coverage.logo:
                                            SheildIcon}
                                        width={'16px'}/>
                                    {data.coverage.value}
                                </td>
                                <td className="wholesaler-table-content-text">
                                    {data.contact.name}
                                </td>
                                <td className="wholesaler-table-content-text">
                                    {data.contact.title? data.contact.title : 'N/A'}
                                    {data.contact.department?
                                        `, ${data.contact.department}`: ', N/A'}
                                </td>
                                <td className="wholesaler-table-content-text">
                                   {data.contact.phone}
                                </td>
                                <td className="wholesaler-table-content-text">
                                    {data.contact.mobile}
                                </td>
                                <td className="wholesaler-table-content-text">
                                    {data.contact.email}
                                </td>
                            </tr>
                            );
                        }): <tr><td colSpan={6}>
                            <Loader/></td></tr>}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
}

export default Wholesaler;
